import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Result } from "@chessalpha/core";
import { TableCell, TableHead, TableRow } from "@ssf/components";
import { useTranslation } from "react-i18next";
const resultMap = {
    [Result.ONGOING]: "*",
    [Result.DRAW]: "2 - 2",
    [Result.WHITEWIN]: "3 - 1",
    [Result.BLACKWIN]: "1 - 3",
    [Result.UNKNOWN]: "?",
};
export const GameRowHead = () => {
    const { t } = useTranslation("GameRowHead");
    return (_jsxs(TableHead, { children: [_jsx(TableCell, { align: "left", children: t("white") }), _jsx(TableCell, { align: "left", children: t("black") }), _jsx(TableCell, { sx: { width: "80px" }, children: t("result") })] }));
};
export function GameRow({ game, ...props }) {
    return (_jsxs(TableRow, { ...props, children: [_jsx(TableCell, { align: "left", nowrap: true, sx: { overflow: "hidden", textOverflow: "ellipsis" }, children: game.white.name }), _jsx(TableCell, { align: "left", nowrap: true, sx: { overflow: "hidden", textOverflow: "ellipsis" }, children: game.black.name }), _jsx(TableCell, { nowrap: true, sx: { height: 32 }, children: resultMap[game.result] || "?" })] }));
}
//# sourceMappingURL=GameRow.js.map